import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { TabForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const EditView = (props: any) => {
    const { tab, onFinish, onFinishFailed, disableEditType } = props;

    return (
        <Layout
            titles={[
                { name: "Tabs", link: "/tab" },
                { name: "Edit", link: "" },
                { name: tab?.name, link: "" },
            ]}
        >
            <MetaTag title="Add Tab" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Tab Update"}
                        bordered={true}
                    >
                        {tab && (
                            <TabForm
                                tab={tab}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                disableEditType={disableEditType}
                            />
                        )}
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default EditView;
